/* ============================================================
   K.NOAH — MOBILE GET YOUR QUOTE FINAL

   REAL SHOPIFY CONTACT FORM
   NO PROGRAMMATIC SUBMIT
   NO CLOUDINARY
   NO PREVIEW LINKS
   NO SECOND FORM
   ============================================================ */

(function () {

  'use strict';


  if (window.KNOAH_MOBILE_QUOTE_FINAL) {
    return;
  }

  window.KNOAH_MOBILE_QUOTE_FINAL = true;


  /* ==========================================================
     CSS
     ========================================================== */

  var style =
    document.createElement('style');


  style.textContent = `

    /* ======================================================
       DESKTOP
       ====================================================== */

    @media (min-width:901px) {

      #kn-mobile-quote-page {
        display:none !important;
      }

    }


    /* ======================================================
       MOBILE
       ====================================================== */

    @media (max-width:900px) {


      /* REVIEW -> GET YOUR QUOTE */

      #knm2 .knm2-parts [data-part="review"] {
        font-size:9px !important;
        letter-spacing:.035em !important;
        white-space:nowrap !important;
      }


      /* ===============================================
         QUOTE MODE
         =============================================== */

      body.knmq-open #frx-configurator {
        padding-bottom:30px !important;
      }


      body.knmq-open #frx-configurator > .frx-preview,
      body.knmq-open #frx-configurator > .frx-controls,
      body.knmq-open #kn-pants-placeholder,
      body.knmq-open #kn-review-placeholder {
        display:none !important;
      }


      body.knmq-open #knm2 .knm2-category,
      body.knmq-open #knm2 .knm2-step {
        display:none !important;
      }


      body.knmq-open #knm2-footer {
        display:none !important;
      }


      /* ===============================================
         PAGE
         =============================================== */

      #kn-mobile-quote-page {
        display:none;
        width:100%;
        max-width:600px;
        margin:0 auto;
        padding:0 9px 35px;
        box-sizing:border-box;
        background:#f5f5f3;
        color:#111;
      }


      body.knmq-open #kn-mobile-quote-page {
        display:block !important;
      }


      /* ===============================================
         HERO
         =============================================== */

      #kn-mobile-quote-page .knmq-hero {
        padding:28px 7px 24px;
      }


      #kn-mobile-quote-page .knmq-kicker {
        display:block;
        margin-bottom:8px;
        font-size:9px;
        font-weight:800;
        letter-spacing:.14em;
        color:#999;
      }


      #kn-mobile-quote-page h2 {
        margin:0;
        font-family:"Barlow Condensed","Arial Narrow",Arial,sans-serif;
        font-size:42px;
        line-height:.92;
        font-weight:700;
        letter-spacing:-.025em;
        text-transform:uppercase;
      }


      #kn-mobile-quote-page .knmq-intro {
        max-width:340px;
        margin:13px 0 0;
        font-size:12px;
        line-height:1.55;
        color:#777;
      }


      /* ===============================================
         CARD
         =============================================== */

      #kn-mobile-quote-page .knmq-card {
        margin-bottom:12px;
        padding:20px 16px;
        background:#fff;
        border:1px solid #deded9;
        border-radius:14px;
        box-sizing:border-box;
      }


      #kn-mobile-quote-page .knmq-step {
        display:block;
        margin-bottom:7px;
        font-size:8px;
        font-weight:800;
        letter-spacing:.14em;
        color:#aaa;
      }


      #kn-mobile-quote-page h3 {
        margin:0 0 18px;
        font-family:"Barlow Condensed","Arial Narrow",Arial,sans-serif;
        font-size:27px;
        line-height:1;
        font-weight:700;
        text-transform:uppercase;
      }


      /* ===============================================
         PRODUCTS
         =============================================== */

      #kn-mobile-quote-page .knmq-products {
        display:grid;
        gap:8px;
        margin-bottom:22px;
      }


      #kn-mobile-quote-page .knmq-product {
        position:relative;
        display:block;
        min-height:68px;
        padding:14px 48px 14px 14px;
        border:1px solid #d9d9d5;
        border-radius:10px;
        background:#fff;
        box-sizing:border-box;
        cursor:pointer;
      }


      #kn-mobile-quote-page .knmq-product input {
        position:absolute;
        opacity:0;
        pointer-events:none;
      }


      #kn-mobile-quote-page .knmq-product strong {
        display:block;
        font-size:11px;
        font-weight:800;
        letter-spacing:.05em;
      }


      #kn-mobile-quote-page .knmq-product small {
        display:block;
        margin-top:4px;
        font-size:10px;
        color:#888;
      }


      #kn-mobile-quote-page .knmq-product:after {
        content:"";
        position:absolute;
        right:16px;
        top:50%;
        width:18px;
        height:18px;
        border:1px solid #bbb;
        border-radius:50%;
        background:#fff;
        box-sizing:border-box;
        transform:translateY(-50%);
      }


      #kn-mobile-quote-page .knmq-product:has(input:checked) {
        border-color:#111;
        background:#f5f5f2;
      }


      #kn-mobile-quote-page .knmq-product:has(input:checked):after {
        border:5px solid #111;
      }


      /* ===============================================
         LABEL
         =============================================== */

      #kn-mobile-quote-page .knmq-label {
        display:block;
        margin:0 0 7px;
        font-size:9px;
        font-weight:800;
        letter-spacing:.08em;
        color:#666;
      }


      /* ===============================================
         QUANTITY
         =============================================== */

      #kn-mobile-quote-page .knmq-quantity {
        display:grid;
        grid-template-columns:52px 1fr 52px;
        height:50px;
        overflow:hidden;
        border:1px solid #d9d9d5;
        border-radius:10px;
        background:#fff;
      }


      #kn-mobile-quote-page .knmq-quantity button {
        margin:0;
        padding:0;
        border:0;
        background:#f5f5f2;
        color:#111;
        font-size:21px;
        cursor:pointer;
      }


      #kn-mobile-quote-page .knmq-quantity input {
        width:100%;
        min-width:0;
        border:0;
        border-left:1px solid #e1e1dd;
        border-right:1px solid #e1e1dd;
        border-radius:0;
        background:#fff;
        text-align:center;
        font-size:15px;
        font-weight:800;
        appearance:textfield;
      }


      #kn-mobile-quote-page
      .knmq-quantity input::-webkit-inner-spin-button,

      #kn-mobile-quote-page
      .knmq-quantity input::-webkit-outer-spin-button {
        -webkit-appearance:none;
        margin:0;
      }


      /* ===============================================
         FORM
         =============================================== */

      #kn-mobile-quote-page .knmq-field {
        margin-bottom:14px;
      }


      #kn-mobile-quote-page input[type="text"],
      #kn-mobile-quote-page input[type="email"],
      #kn-mobile-quote-page input[type="tel"],
      #kn-mobile-quote-page textarea:not([hidden]) {
        width:100%;
        min-height:48px;
        padding:12px 13px;
        box-sizing:border-box;
        border:1px solid #d9d9d5;
        border-radius:9px;
        outline:0;
        background:#fff;
        color:#111;
        font-family:inherit;
        font-size:16px;
        box-shadow:none;
        appearance:none;
      }


      #kn-mobile-quote-page textarea:not([hidden]) {
        min-height:105px;
        resize:vertical;
      }


      #kn-mobile-quote-page input:focus,
      #kn-mobile-quote-page textarea:focus {
        border-color:#111;
      }


      /* ===============================================
         SHOPIFY ERRORS
         =============================================== */

      #kn-mobile-quote-page .errors {
        margin:0 0 12px;
        padding:14px 16px;
        border:1px solid #e0b9b9;
        border-radius:10px;
        background:#fff5f5;
        color:#8c2525;
        font-size:11px;
        line-height:1.5;
      }


      /* ===============================================
         SUBMIT
         =============================================== */

      #kn-mobile-quote-page .knmq-submit {
        width:100%;
        min-height:54px;
        margin-top:4px;
        border:0;
        border-radius:999px;
        background:#111;
        color:#fff;
        font-size:11px;
        font-weight:900;
        letter-spacing:.07em;
        cursor:pointer;
      }


      #kn-mobile-quote-page .knmq-submit:disabled {
        opacity:.55;
      }


      /* ===============================================
         STATUS
         =============================================== */

      #kn-mobile-quote-page .knmq-status {
        display:none;
        margin-top:12px;
        padding:12px;
        border-radius:9px;
        background:#f4f4f1;
        font-size:10px;
        line-height:1.45;
        text-align:center;
        color:#666;
      }


      #kn-mobile-quote-page .knmq-status.visible {
        display:block;
      }


      /* ===============================================
         SUCCESS
         =============================================== */

      #kn-mobile-quote-page .knmq-success {
        margin-bottom:12px;
        padding:28px 20px;
        border:1px solid #d7d7d2;
        border-radius:14px;
        background:#fff;
      }


      #kn-mobile-quote-page .knmq-success strong {
        display:block;
        margin-bottom:8px;
        font-family:"Barlow Condensed","Arial Narrow",Arial,sans-serif;
        font-size:30px;
        line-height:1;
        font-weight:700;
      }


      #kn-mobile-quote-page .knmq-success p {
        margin:0;
        max-width:360px;
        color:#777;
        font-size:12px;
        line-height:1.55;
      }

    }

  `;


  document.head.appendChild(
    style
  );


  /* ==========================================================
     HELPERS
     ========================================================== */

  function clean(value) {

    return String(
      value == null ? '' : value
    ).trim();

  }


  function getPage() {

    return document.getElementById(
      'kn-mobile-quote-page'
    );

  }


  function getForm() {

    return document.getElementById(
      'knmq-form'
    );

  }


  function value(id) {

    var element =
      document.getElementById(id);


    return element
      ? clean(element.value)
      : '';

  }


  function getProduct() {

    var selected =
      document.querySelector(
        '#knmq-form input[name="contact[product]"]:checked'
      );


    return selected
      ? clean(selected.value)
      : 'Full Uniform';

  }


  /* ==========================================================
     CONFIGURATION
     ========================================================== */

  function getConfiguration() {

    if (
      window.KNoahQuoteData &&
      typeof window.KNoahQuoteData.toText ===
        'function'
    ) {

      try {

        var configuration =
          window.KNoahQuoteData.toText();


        if (configuration) {

          return configuration;

        }

      } catch (error) {

        console.error(
          'K.NOAH MOBILE FINAL — configuration error:',
          error
        );

      }

    }


    return (
      'MODEL: FRX\n\n' +
      'CONFIGURATION DATA UNAVAILABLE'
    );

  }


  /* ==========================================================
     BUILD SHOPIFY MESSAGE
     ========================================================== */

  function buildMessage() {

    var lines = [];


    lines.push(
      'K.NOAH — NEW UNIFORM QUOTE REQUEST'
    );


    lines.push('');
    lines.push(
      '========================================'
    );

    lines.push(
      'CUSTOMER'
    );

    lines.push(
      '========================================'
    );


    lines.push(
      'Name: ' +
      value('knmq-contact')
    );


    lines.push(
      'Team / Organization: ' +
      value('knmq-team')
    );


    lines.push(
      'Email: ' +
      value('knmq-email')
    );


    lines.push(
      'Phone: ' +
      (
        value('knmq-phone') ||
        '—'
      )
    );


    lines.push(
      'Country: ' +
      (
        value('knmq-country') ||
        '—'
      )
    );


    lines.push('');
    lines.push(
      '========================================'
    );

    lines.push(
      'REQUEST'
    );

    lines.push(
      '========================================'
    );


    lines.push(
      'Model: FRX'
    );


    lines.push(
      'Product: ' +
      getProduct()
    );


    lines.push(
      'Quantity: ' +
      (
        value('knmq-quantity') ||
        '1'
      )
    );


    lines.push('');
    lines.push(
      '========================================'
    );

    lines.push(
      'CONFIGURATION'
    );

    lines.push(
      '========================================'
    );

    lines.push('');


    lines.push(
      getConfiguration()
    );


    lines.push('');
    lines.push(
      '========================================'
    );

    lines.push(
      'MESSAGE / NOTES'
    );

    lines.push(
      '========================================'
    );


    lines.push(
      value('knmq-message') ||
      '—'
    );


    lines.push('');
    lines.push(
      '========================================'
    );


    lines.push(
      'Sent via K.NOAH Mobile Uniform Configurator.'
    );


    return lines.join(
      '\n'
    );

  }


  /* ==========================================================
     QUANTITY
     ========================================================== */

  function bindQuantity() {

    var page =
      getPage();


    if (!page) {
      return;
    }


    var qty =
      document.getElementById(
        'knmq-quantity'
      );


    var minus =
      document.getElementById(
        'knmq-minus'
      );


    var plus =
      document.getElementById(
        'knmq-plus'
      );


    if (
      !qty ||
      !minus ||
      !plus
    ) {
      return;
    }


    if (
      page.dataset.knmqQuantityBound ===
      '1'
    ) {
      return;
    }


    page.dataset.knmqQuantityBound =
      '1';


    minus.addEventListener(
      'click',
      function () {

        var current =
          parseInt(
            qty.value || '1',
            10
          );


        qty.value =
          Math.max(
            1,
            current - 1
          );

      }
    );


    plus.addEventListener(
      'click',
      function () {

        var current =
          parseInt(
            qty.value || '1',
            10
          );


        qty.value =
          current + 1;

      }
    );

  }


  /* ==========================================================
     FORM

     CRITICAL:
     We DO NOT preventDefault().
     We DO NOT requestSubmit().
     We DO NOT call form.submit().

     User's original button click performs the real
     Shopify Contact Form submission.
     ========================================================== */

  function bindForm() {

    var form =
      getForm();


    if (!form) {
      return false;
    }


    if (
      form.dataset.knmqFinalBound ===
      '1'
    ) {
      return true;
    }


    form.dataset.knmqFinalBound =
      '1';


    form.addEventListener(
      'submit',
      function (event) {

        /*
          Do NOT preventDefault.
        */


        if (
          !form.checkValidity()
        ) {

          /*
            Browser will stop invalid form itself.
            We only ensure the fields are shown.
          */

          return;

        }


        var body =
          document.getElementById(
            'knmq-body'
          );


        if (!body) {

          console.error(
            'K.NOAH MOBILE FINAL — contact[body] field missing.'
          );

          return;

        }


        /*
          Build all configuration information
          synchronously BEFORE the native POST.
        */

        body.value =
          buildMessage();


        console.log(
          'K.NOAH MOBILE FINAL — native Shopify submission.'
        );


        console.log(
          body.value
        );


        /*
          IMPORTANT:
          Nothing else happens here.

          No:
          - preventDefault()
          - requestSubmit()
          - form.submit()
          - fetch()
          - Cloudinary
          - second form

          Browser + Shopify handle the POST normally.
        */

      },

      false
    );


    return true;

  }


  /* ==========================================================
     OPEN
     ========================================================== */

  function openQuote() {

    if (
      window.innerWidth > 900
    ) {
      return;
    }


    var page =
      getPage();


    if (!page) {

      console.error(
        'K.NOAH MOBILE FINAL — Liquid quote page not found.'
      );

      return;
    }


    document.body.classList.add(
      'knmq-open'
    );


    var buttons =
      document.querySelectorAll(
        '#knm2 .knm2-parts [data-part]'
      );


    buttons.forEach(
      function (button) {

        button.classList.toggle(
          'active',
          button.dataset.part ===
            'review'
        );

      }
    );


    window.setTimeout(
      function () {

        page.scrollIntoView({
          behavior:'smooth',
          block:'start'
        });

      },

      30
    );

  }


  /* ==========================================================
     CLOSE
     ========================================================== */

  function closeQuote() {

    document.body.classList.remove(
      'knmq-open'
    );

  }


  /* ==========================================================
     NAVIGATION
     ========================================================== */

  function installNavigation() {

    if (
      window.innerWidth > 900
    ) {

      closeQuote();

      return false;

    }


    var nav =
      document.querySelector(
        '#knm2 .knm2-parts'
      );


    if (!nav) {
      return false;
    }


    var review =
      nav.querySelector(
        '[data-part="review"]'
      );


    if (!review) {
      return false;
    }


    review.textContent =
      'GET YOUR QUOTE';


    if (
      nav.dataset.knmqFinalInstalled ===
      '1'
    ) {

      return true;

    }


    nav.dataset.knmqFinalInstalled =
      '1';


    nav.addEventListener(
      'click',

      function (event) {

        if (
          window.innerWidth > 900
        ) {
          return;
        }


        var button =
          event.target.closest(
            '[data-part]'
          );


        if (!button) {
          return;
        }


        /*
          JERSEY / PANTS

          Close Quote Mode and let the original
          configurator handler continue normally.
        */

        if (
          button.dataset.part !==
          'review'
        ) {

          closeQuote();

          return;

        }


        /*
          GET YOUR QUOTE

          Only intercept the old Review behavior.
        */

        event.preventDefault();

        event.stopPropagation();

        event.stopImmediatePropagation();


        openQuote();

      },

      true
    );


    return true;

  }


  /* ==========================================================
     SUCCESS PAGE

     If Shopify returned after a successful contact
     submission and Liquid rendered #knmq-success,
     automatically open GET YOUR QUOTE.
     ========================================================== */

  function checkSuccess() {

    var success =
      document.getElementById(
        'knmq-success'
      );


    if (
      !success ||
      window.innerWidth > 900
    ) {
      return;
    }


    document.body.classList.add(
      'knmq-open'
    );

  }


  /* ==========================================================
     START
     ========================================================== */

  function start() {

    bindQuantity();

    bindForm();

    checkSuccess();


    var tries = 0;


    var timer =
      window.setInterval(
        function () {

          tries++;


          bindQuantity();

          bindForm();

          checkSuccess();


          var installed =
            installNavigation();


          if (
            installed ||
            tries > 100
          ) {

            window.clearInterval(
              timer
            );

          }

        },

        100
      );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once:true }
    );

  } else {

    start();

  }


  /* ==========================================================
     RESIZE
     ========================================================== */

  window.addEventListener(
    'resize',
    function () {

      if (
        window.innerWidth > 900
      ) {

        closeQuote();

      } else {

        installNavigation();

      }

    }
  );


  /* ==========================================================
     DEBUG
     ========================================================== */

  window.KNoahMobileQuote = {

    open:
      openQuote,

    close:
      closeQuote,

    buildMessage:
      buildMessage,

    configuration:
      getConfiguration

  };


  console.log(
    'K.NOAH Mobile Quote FINAL loaded — native Shopify form.'
  );

})();